import { useMemo } from "react";
import German from "domains/messages/compiled-locales/de/messages.json";
import English from "domains/messages/compiled-locales/en/messages.json";
import Spanish from "domains/messages/compiled-locales/es/messages.json";
import French from "domains/messages/compiled-locales/fr/messages.json";
import Hindi from "domains/messages/compiled-locales/hi/messages.json";
import Japanese from "domains/messages/compiled-locales/ja/messages.json";
import Portuguese from "domains/messages/compiled-locales/pt/messages.json";
import Chinese from "domains/messages/compiled-locales/zh/messages.json";
import useRouter from "domains/navigation/hooks/useRouter";
import { IntlProvider as IntlProviderFromLib } from "react-intl";

export const IntlProvider = ({ children }: { children: React.ReactNode }) => {
  const { locale } = useRouter();
  const [shortLocale] = (locale as string | undefined)?.split("-") ?? ["en"];
  const messages = useMemo(() => {
    switch (shortLocale) {
      case "fr":
        return French;
      case "de":
        return German;
      case "es":
        return Spanish;
      case "hi":
        return Hindi;
      case "pt":
        return Portuguese;
      case "en":
        return English;
      case "zh":
        return Chinese;
      case "ja":
        return Japanese;
      default:
        return English;
    }
  }, [shortLocale]);

  return (
    <IntlProviderFromLib
      timeZone={Intl.DateTimeFormat().resolvedOptions().timeZone}
      locale={shortLocale}
      messages={messages}
      onError={() => null}
      //   defaultRichTextElements={
      //     // {
      //       // how to have rich text in the translations
      //       // strong: (chunks) => <strong>{chunks}</strong>,
      //     // }
      //   }
    >
      {children}
    </IntlProviderFromLib>
  );
};
